import React, { useContext, memo, useEffect } from "react"

import Link from "~components/Link"
import { GatsbyImage } from "gatsby-plugin-image"
import { withSession } from "~contexts/SessionContext"

import MicrocopyContext from "~contexts/MicrocopyContext"
import { graphql, StaticQuery } from "gatsby"
import * as style from "./Banner.module.scss"

const Banner = withSession(({ children, session }) => {
  const microcopy = useContext(MicrocopyContext)

  useEffect(() => {
    const elements = document.querySelectorAll("#banner h1")
    let index = 0

    const interval = setInterval(() => {
      elements[index].setAttribute("data-active", false)
      index = ++index % elements.length
      elements[index].setAttribute("data-active", true)
    }, 6000)

    return () => clearInterval(interval)
  }, [])

  return (
    <StaticQuery
      query={query}
      render={(data) => (
        <section className={style.banner} id="banner">
          <div>
            <section className={style.text}>
              {children}
              <div className={style.buttons}>
                <Link
                  to="/platform"
                  microcopy={microcopy}
                  className={style.button}
                  data-type="get-started"
                >
                  {microcopy.text("guides.titles.get_started", "Get started")}
                </Link>
                {!session.hasAccount ? (
                  <Link
                    to={microcopy.text("headers.primary.buttons.signup.url")}
                    microcopy={microcopy}
                    className={style.button}
                    data-type="signup"
                  >
                    {microcopy.text("headers.primary.buttons.signup.text")}
                  </Link>
                ) : (
                  <Link
                    to={microcopy.text(
                      "headers.primary.buttons.dashboard.url",
                      "https://account.box.com/developers/console",
                    )}
                    microcopy={microcopy}
                    className={style.button}
                    data-type="signup"
                  >
                    {microcopy.text(
                      "headers.primary.buttons.dashboard.text",
                      "Go to Dev Console",
                    )}
                  </Link>
                )}
              </div>
            </section>
            <section className={style.image}>
              <div>
                <GatsbyImage
                  alt=""
                  image={data.file.childImageSharp.gatsbyImageData}
                />
              </div>
            </section>
          </div>
        </section>
      )}
    />
  )
})

const query = graphql`
  query {
    file(
      relativePath: { eq: "platform.png" }
      sourceInstanceName: { eq: "pages" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      }
    }
  }
`

export default memo(Banner)
export { default as Title } from "./Title"
